import { environment } from '../environments/environment';

export const AppConstants = {
    endpoint: {

        attachment: {
            base: environment.apiBaseUrl + '/attachments',
            get: environment.apiBaseUrl + '/attachments/{id}',
            delete: environment.apiBaseUrl + '/attachments/{id}/delete',
            updateIsValid: environment.apiBaseUrlPython + '/updateAttachmentIsValid',
            updateComments: environment.apiBaseUrlPython + '/updateAttachmentComments',
        },
        
        auth: {
            login: environment.apiBaseUrl + '/auth/login',
            loginSocial: environment.apiBaseUrl + '/auth/login/social',
            activate: environment.apiBaseUrl + '/auth/account/activate',
            activate_request: environment.apiBaseUrl + '/auth/account/activate-request',
            password: {
                changePassword: environment.apiBaseUrl + '/auth/change-password',
                forgot: environment.apiBaseUrl + '/auth/password/forgot',
                reset: environment.apiBaseUrl + '/auth/password/reset'
            },
            aboutBuildVersion: environment.apiBaseUrl + '/user-profile/aboutBuildVersion',
            aboutBuildVersionPython: environment.apiBaseUrlPython + '/aboutBuildVersion',
            user_profile: environment.apiBaseUrl + '/user-profile'
        },
        register: {
            user: environment.apiBaseUrl + '/register',
            social: environment.apiBaseUrl + '/register/social'
        },
        blog: {
            base: environment.apiBaseUrl + '/blogs',
            summaries: environment.apiBaseUrl + '/blogs/summaries',
            get: environment.apiBaseUrl + '/blogs/{id}',
            general_info: environment.apiBaseUrl + '/blogs/{id}/general-info',
            content: environment.apiBaseUrl + '/blogs/{id}/content',
            image: environment.apiBaseUrl + '/blogs/{id}/image',
            publish: environment.apiBaseUrl + '/blogs/{id}/publish',
            unpublish: environment.apiBaseUrl + '/blogs/{id}/unpublish',
            delete: environment.apiBaseUrl + '/blogs/{id}/delete'
        },
        institute: {
            base: environment.apiBaseUrl + '/institutes',
            summaries: environment.apiBaseUrl + '/institutes/summaries',
            get: environment.apiBaseUrl + '/institutes/{id}',
            general_info: environment.apiBaseUrl + '/institutes/{id}/general-info',
            about: environment.apiBaseUrl + '/institutes/{id}/about',
            benefits: environment.apiBaseUrl + '/institutes/{id}/benefits',
            images: environment.apiBaseUrl + '/institutes/{id}/images',
            publish: environment.apiBaseUrl + '/institutes/{id}/publish',
            delete: environment.apiBaseUrl + '/institutes/{id}/delete',
            courses: environment.apiBaseUrl + '/institutes/{id}/courses',
            getAll: environment.apiBaseUrl + '/institutes/get-all',
            branding: environment.apiBaseUrlPython + '/institutes/branding',
            details: environment.apiBaseUrlPython + '/institutes/details',
            qrCodes: environment.apiBaseUrlPython + '/institutes/{id}/qr-codes',
            qrCodeDelete: environment.apiBaseUrlPython + '/institutes/{id}/qr-codes/{qrId}',
            qrUsers: environment.apiBaseUrlPython + '/institutes/{id}/qr-users',
        },
        qrCode: {
            publicInfo: environment.apiBaseUrlPython + '/public/qr/{token}',
            publicRegister: environment.apiBaseUrlPython + '/public/qr/{token}/register',
            publicStaticData: environment.apiBaseUrlPython + '/public/registration-static-data',
        },
        studentInvite: {
            qrCodes: environment.apiBaseUrlPython + '/student-invite/qr-codes',
            send: environment.apiBaseUrlPython + '/student-invite/send',
            agents: environment.apiBaseUrlPython + '/student-invite/agents',
        },
        company: {
            base: environment.apiBaseUrl + '/companies',
            get: environment.apiBaseUrl + '/companies/{id}'
        },
        agency: {
            base: environment.apiBaseUrl + '/agencies',
            get: environment.apiBaseUrl + '/agencies/{id}'
        },
        course: {
            base: environment.apiBaseUrl + '/courses',
            summaries: environment.apiBaseUrl + '/courses/summaries',
            get: environment.apiBaseUrl + '/courses/{id}',
            check_eligibility: environment.apiBaseUrl + '/courses/{id}/check-eligibility',
            general_info: environment.apiBaseUrl + '/courses/{id}/general-info',
            updateCourseWithGeneralInfo: environment.apiBaseUrl + '/courses/{id}/updateCourseWithGeneralInfo',
            description: environment.apiBaseUrl + '/courses/{id}/description',
            admission_req: environment.apiBaseUrl + '/courses/{id}/admission-req',
            fees: environment.apiBaseUrl + '/courses/{id}/fees',
            date: environment.apiBaseUrl + '/courses/{id}/dates',
            requirement_eng: environment.apiBaseUrl + '/courses/{id}/requirement/english',
            requirement_academic: environment.apiBaseUrl + '/courses/{id}/requirement/academic',
            requirement_general: environment.apiBaseUrl + '/courses/{id}/requirement/general',
            publish: environment.apiBaseUrl + '/courses/{id}/publish',
            delete: environment.apiBaseUrl + '/courses/{id}/delete',
            softDeleteCourse: environment.apiBaseUrl + '/courses/course/{id}',
            softDeleteBatch: environment.apiBaseUrl + '/courses/course-date/{id}',
            getCourseDateDetails: environment.apiBaseUrl + '/courses/getCourseDateDetails/{id}',
            course_dates: environment.apiBaseUrl + '/courses/{id}/course-dates',
            getAllCoursesWithSessions: environment.apiBaseUrl + '/courses/getAllCoursesWithSessions/{id}',
            admission_requirements: environment.apiBaseUrl + '/courses/{id}/requirements',
            // This endpoint belongs to FastAPI, outside its existing /v4 route group.
            interview_questions: environment.apiBaseUrlPython.replace(/\/v4\/$/, '').replace(/\/v4$/, '') + '/studyoffer/courses/{id}/interview-questions',
            admission_add_requirements: environment.apiBaseUrl + '/courses/requirements',
            audit_trail: environment.apiBaseUrl + '/course-audit-logs/getByCourseId',
            batch_status_counts: environment.apiBaseUrlPython + '/courses/{id}/batch-status-counts'
        },
        checklist: {
            add: environment.apiBaseUrl + '/courses/addchecklist',
            bySource: environment.apiBaseUrl + '/courses/bysource',
            update: environment.apiBaseUrl + '/courses/updatechecklist',
        },
        course_application: {
            base: environment.apiBaseUrl + '/course-applications',
            get: environment.apiBaseUrl + '/course-applications/{id}',            
            documents: environment.apiBaseUrl + '/course-applications/{id}/document',
            stats: environment.apiBaseUrl + '/course-applications/stats',
        },
        referral: {
            base: environment.apiBaseUrl + '/referrals',
            get: environment.apiBaseUrl + '/referrals/{id}',
            payment: environment.apiBaseUrl + '/referrals/{id}/payment'
        },
        guest: {
            contact_us: environment.apiBaseUrl + '/guest/contact-us',
            newletter_signup: environment.apiBaseUrl + '/guest/newsletter-signup',
            lead_details: environment.apiBaseUrl + '/guest/lead-details',
        },
        lead: {
            base: environment.apiBaseUrl + '/leads',
            get: environment.apiBaseUrl + '/leads/{id}',
            delete: environment.apiBaseUrl + '/leads/{id}/delete'
        },
        note: {
            base: environment.apiBaseUrl + '/notes',
            get: environment.apiBaseUrl + '/notes/{id}',
            delete: environment.apiBaseUrl + '/notes/{id}/delete'
        },
        static: {
            id: environment.apiBaseUrl + '/static/{id}',
            type: environment.apiBaseUrl + '/static/type',
            countries: environment.apiBaseUrl + '/static/countries',
            states: environment.apiBaseUrl + '/static/states',
            cities: environment.apiBaseUrl + '/static/cities',
            hierarchy: environment.apiBaseUrl + '/static/hierarchy',
        },
        student: {
            base: environment.apiBaseUrl + '/students',
            softDeleteStudent: environment.apiBaseUrl + '/students/student/{id}',
            students_journeys: environment.apiBaseUrl + '/students-journeys',
            download_student_documents_zip: environment.apiBaseUrlPython + '/students-journeys/documents/download-zip',
            student_application_filter: environment.apiBaseUrl + '/students/filter',
            filter: environment.apiBaseUrl + '/students/student-applications/filter',
            student_application: environment.apiBaseUrl + '/students/studentApplication',
            partners: environment.apiBaseUrl + '/students/partners',
            stats: environment.apiBaseUrl + '/students/stats',
            get: environment.apiBaseUrl + '/students/{id}',
            general_info: environment.apiBaseUrl + '/students/{id}/general-info',
            education_summary: environment.apiBaseUrl + '/students/{id}/education-summary',
            education_history: environment.apiBaseUrl + '/students/{id}/education-history',
            test_score: environment.apiBaseUrl + '/students/{id}/test-score',
            background_info: environment.apiBaseUrl + '/students/{id}/background-info',
            documents: environment.apiBaseUrl + '/students/{id}/document',
            checklist: environment.apiBaseUrl + '/students/{id}/checklist',
            checklist_status: environment.apiBaseUrl + '/students-journeys/status/{id}',
            approve_partner: environment.apiBaseUrl + '/students/{id}/approve',
            revoke_approval_partner: environment.apiBaseUrl + '/students/{id}/revoke-approval',
            partner_company: environment.apiBaseUrl + '/students/{id}/partner-company',
            banking_info: environment.apiBaseUrl + '/students/{id}/banking-info',
            course_applications: environment.apiBaseUrl + '/students/course-applications',
            moodle: environment.apiBaseUrl + '/moodle/fetch-student-course-marks',
            college_forms: environment.apiBaseUrl + '/college-forms',
            college_forms_v4: environment.apiBaseUrlPython + '/college-forms',
            admission_requirements: environment.apiBaseUrl + '/admission-requirements',
            studentWithEnrollments: environment.apiBaseUrl + '/students-journeys/studentWithEnrollments',
            softDeleteStudentApplication: environment.apiBaseUrl + '/students-journeys/student-application/{id}',
            request_document_upload_link: environment.apiBaseUrlPython + '/students/upload-link',
            fee_reminder: environment.apiBaseUrlPython + '/students/fee-reminder',
            payment_receipt: environment.apiBaseUrlPython + '/students/{studentId}/payments/{paymentId}/receipt',
            email_payment_receipt: environment.apiBaseUrlPython + '/students/{studentId}/payments/{paymentId}/email-receipt',
            email_birt_receipt: environment.apiBaseUrlPython + '/students/{studentId}/email-birt-receipt',
            my_applications: environment.apiBaseUrlPython + '/student-applications/my',
            transfer_student_course_application: environment.apiBaseUrl + '/students-journeys/transfer-student-course-application',
            student_institute_transfer: environment.apiBaseUrl + '/student-institute-transfer/transfer',
            student_institute_transfer_institutes: environment.apiBaseUrl + '/student-institute-transfer/institutes',
            transfer_courses: environment.apiBaseUrlPython + '/transfer/courses',
            transfer_batches: environment.apiBaseUrlPython + '/transfer/batches',
            batch_details: environment.apiBaseUrlPython + '/batch/{id}',
            batch_stats: environment.apiBaseUrlPython + '/batch/{id}/stats',
            batch_students_by_payment: environment.apiBaseUrlPython + '/batch/{id}/students-by-payment',
            batch_clone: environment.apiBaseUrlPython + '/batch/{id}/clone',
            audit_trail: environment.apiBaseUrl + '/student-audit-logs/getJourneyByScaId',
            audit_trail_by_student: environment.apiBaseUrl + '/student-audit-logs/getByStudentId',
            interaction_base: environment.apiBaseUrl + '/student-interactions',
            interaction_by_student: environment.apiBaseUrl + '/student-interactions/student/{studentId}',
            interaction_by_sca: environment.apiBaseUrl + '/student-interactions/by-sca/{scaId}',
            interaction_update: environment.apiBaseUrl + '/student-interactions/{id}',
            interaction_delete: environment.apiBaseUrl + '/student-interactions/{id}',
            interview_completed: environment.apiBaseUrlPython + '/student-course-application/{id}/interview-completed',
            interview_questionnaire: environment.apiBaseUrlPython + '/student-course-applications/{id}/interview-questionnaire',
            document_status: environment.apiBaseUrlPython + '/student-course-applications/{id}/document-status',
            evaluation_candidates: environment.apiBaseUrlPython + '/evaluation/candidates',
            evaluation_invite: environment.apiBaseUrlPython + '/evaluation/candidates/invite',
            evaluation_invitations: environment.apiBaseUrlPython + '/evaluation/candidates/{scaId}/invitations',
            evaluation_tests: environment.apiBaseUrlPython + '/evaluation/tests',
            evaluation_report: environment.apiBaseUrlPython + '/evaluation/reports/{reportCode}',
            moodle_sync: environment.apiBaseUrlPython + '/syncStudentCourseCredentials',
            moodle_credentials: environment.apiBaseUrlPython + '/getStudentCourseCredentials',
        },
        file: {
            upload: {
                image: environment.apiBaseUrl + '/files/upload/image',
                document: environment.apiBaseUrl + '/files/upload/document'
            },
            download: {
                document: environment.apiBaseUrl + '/files/download/document/{id}'
            }            
        },
        screen: {
            base: environment.apiBaseUrl + '/screens',
            access_control: environment.apiBaseUrl + '/access-control/screens-access'
        },
        role: {
            base: environment.apiBaseUrl + '/roles',
            filter: environment.apiBaseUrl + '/roles/filter',
            get: environment.apiBaseUrl + '/roles/{id}/screens',
            create: environment.apiBaseUrl + '/roles/createRoleWithScreens',
            update: environment.apiBaseUrl + '/roles/updateRoleWithScreens/{id}',
            update_role: environment.apiBaseUrl + '/access-control/update',
            delete: environment.apiBaseUrl + '/roles/{id}',
        },
        user: {
            base: environment.apiBaseUrl + '/user-profile',
            get: environment.apiBaseUrl + '/user-profile/{id}',
            getAllUser: environment.apiBaseUrl + '/user-profile/getAllUser',
            settings: environment.apiBaseUrlPython + '/user/settings',
        },
        agent: {
            getAll: environment.apiBaseUrl + '/user-profile/getAllAgents',
            get: environment.apiBaseUrl + '/user-profile/getAgent/{id}',
            save: environment.apiBaseUrl + '/user-profile/saveAgent',
            update: environment.apiBaseUrl + '/user-profile/updateAgent/{id}',
            delete: environment.apiBaseUrl + '/user-profile/agent/{id}',
            deleteAgentPayment: environment.apiBaseUrl + '/user-profile/agentPayment/{id}',
            getAllWithoutUserAccess: environment.apiBaseUrl + '/user-profile/getAllAgentsWithoutUsersAccess',
            getAllAgentPaymentDetails: environment.apiBaseUrl + '/user-profile/getAllAgentPaymentDetails',
            createPayment: environment.apiBaseUrl + '/user-profile/addAgentPayment'
        },
        Docusign: {
            sendDocumentsForSignature: environment.apiBaseUrlPython + '/send_documents_for_signature',
            checkStudentDocumentStatus: environment.apiBaseUrlPython + '/students/{student_id}/courses/{course_application_id}/documents/status',
            voidEnvelope: environment.apiBaseUrlPython + '/void_envelope',
        },
        moodle: {
            getMoodleCoursesList: environment.apiBaseUrlPython + '/getCoursesList',
            syncStudentCourseCredentials: environment.apiBaseUrlPython + '/syncStudentCourseCredentials',
            getStudentCourseCredentials: environment.apiBaseUrlPython + '/getStudentCourseCredentials'
        },
        report: {
            t2202Form: environment.apiBaseUrlPython + '/t2202-form',
        },
        t2202Xml: {
            generate: environment.apiBaseUrlPython + '/t2202-xml/generate',
            generateDownload: environment.apiBaseUrlPython + '/t2202-xml/generate/download',
            validate: environment.apiBaseUrlPython + '/t2202-xml/validate',
            supportedYears: environment.apiBaseUrlPython + '/t2202-xml/supported-years',
            studentDataDownload: environment.apiBaseUrlPython + '/t2202-xml/student-data/download',
            pdfGenerateDownload: environment.apiBaseUrlPython + '/t2202-pdf/generate/download',
        },
        reportsV2: {
            studentsDownload: environment.apiBaseUrl + '/reports/students/download',
        },
        accountingReports: {
            studentPaymentBreakdown: environment.apiBaseUrlPython + '/reports/accounting/student-payment-breakdown',
            pendingBalances: environment.apiBaseUrlPython + '/reports/accounting/pending-balances',
            batchSummary: environment.apiBaseUrlPython + '/reports/accounting/batch-summary',
        },
        placementPartner: {
            partner: {
                create: environment.apiBaseUrl + '/placement-partner/partner/create',
                delete: environment.apiBaseUrl + '/placement-partner/partner/delete/{id}',
                get: environment.apiBaseUrl + '/placement-partner/partner/get/{id}',
                getAll: environment.apiBaseUrl + '/placement-partner/partner/getAll',
                update: environment.apiBaseUrl + '/placement-partner/partner/update/{id}'
            },
            location: {
                create: environment.apiBaseUrl + '/placement-partner/location/create',
                delete: environment.apiBaseUrl + '/placement-partner/location/delete/{id}',
                get: environment.apiBaseUrl + '/placement-partner/location/get/{id}',
                getAll: environment.apiBaseUrl + '/placement-partner/location/getAll',
                update: environment.apiBaseUrl + '/placement-partner/location/update/{id}'
            },
            application: {
                create: environment.apiBaseUrl + '/placement-partner/application/create',
                delete: environment.apiBaseUrl + '/placement-partner/application/delete/{id}',
                get: environment.apiBaseUrl + '/placement-partner/application/get/{id}',
                getAll: environment.apiBaseUrl + '/placement-partner/application/getAll',
                update: environment.apiBaseUrl + '/placement-partner/application/update/{id}',
                studentdropdown: environment.apiBaseUrl + '/placement-partner/application/studentdropdown',
            }
        },
        settings: {
            instituteSetting: environment.apiBaseUrl + '/settings/{instituteId}/institute-setting'
        },
        integrations: {
            info: environment.apiBaseUrlPython + '/integrations/info',
            config: environment.apiBaseUrlPython + '/integrations/config'
        },
        formTemplate: {
            base: environment.apiBaseUrlPython + '/form-templates',
            get: environment.apiBaseUrlPython + '/form-templates/{id}',
            history: environment.apiBaseUrlPython + '/form-templates/{id}/history',
            historyVersion: environment.apiBaseUrlPython + '/form-templates/{id}/history/{version}',
            prefill: environment.apiBaseUrlPython + '/form-templates/{id}/prefill',
            getSmartFields: environment.apiBaseUrlPython + '/form-templates/get-smart-fields',
            uploadImage: environment.apiBaseUrlPython + '/upload-image',
            refreshImageUrls: environment.apiBaseUrlPython + '/refresh-image-urls',
        }
        
    },

    pattern: {
        phone: '[0-9]{8,10}',
        //phone: '[0-9]{10}',
        digit: /^[0-9]+$/
    },

    socialAuthProvider: {
        facebook: {
            appId: '278434756336370' // ghelp-dev
        }
    },

    // google clould
    google_cloud_api_key: '',
       
    char_more: '...',
    authTokenKey: 'CAS_Token', // // use to store the authenticated user token
    http_header_page_count: 'X-Page-Count',
    http_header_page_size: 'X-Page-Size',
    http_header_total_count: 'X-Total-Count',

    // exclusion list for static data
    exclude_from_course_level: [1205, 1206],
    
    //authUserKey: 'auth_user', // use to store the authenticated user profile
    //appConfig: 'helphunt_app_config'
    key: {
        session: {
            institute_detail: 'institute_detail',
            selectedInstituteId: 'selectedInstituteId',
            search_course: 'study_offer_search_course_criteria',
            search_institute: 'study_offer_search_institute_criteria'
        }
    }

};
